<template>
    <footer class="tc">
        <div id="kki55zq0-footer"  class="tc">
            <div class="w1200 dib h70">
                <div id="main-kkm04spl">
                    <div class="main-container">
                        <ul class="main">
                            <!-- 服务热线 -->
                            <li>
                                <img src="@/assets/img/kf.png" alt="">
                                <div class="fs14 cw fwb fwrx">{{ ast['kki5prgj-Fitem'].body[0].body[0].value }}</div>
                                <div class="fs20 cw fwb">{{ ast['kki5prgj-Fitem'].body[1].body[0].value }}</div>
                                <div class="fs12 cw">{{ ast['kki5prgj-Fitem'].body[2].body[0].value }}</div>
                            </li>
                            <!-- 关于我们 -->
                            <li>
                                <div class="fs14 cw fwb mb5">{{ ast['kklygt47-Fitem'].body[0].body[0].value }}</div>
                                <div>
                                    <a :href="item.attributeMap.href.value.value" class="fs12 db cw" v-for="(item,index) in ast['kklygt47-Fitem'].body[1].body" :key="index">{{ item.body[0].value }}</a>
                                </div>
                            </li>
                            <!-- 联系我们 -->
                            <li class="tl">
                                <div class="fs14 cw fwb mb5">{{ ast['kklyuaqa-Fitem'].body[0].body[0].value }}</div>
                                <div class="fs12 cw" v-for="(item,index) in ast['kklyuaqa-Fitem'].body[1].body" :key="index">{{ item.body[0].value }}</div>
                            </li>
                        </ul>
                        <!-- 二维码 -->
                        <div class="gzh-box">
                            <img class="db mb10" src="@/assets/img/gzh.png" alt="">
                            <span class="fs12 cw">{{ ast['kklz37dl-Fitem'].body[0].body[0].value }}</span>
                        </div>
                    </div>
                </div>
                
                <!-- 友情链接 -->
                <div id="kkm0gpz1-link">
                    <div class="fs12 cw dib mr20">{{ ast['kki5styy-link'].body[0].body[0].value }}</div>
                    <div class="dib">
                        <a :href="item.attributeMap.href.value.value" target="_blank" class="fs12 cw" v-for="(item,index) in ast['kki5styy-link'].body[1].body" :key="index">{{ item.body[0].value }}</a>
                    </div>
                </div>
            </div>
        </div>
        <!-- Copyright -->
        <div style="background-color: #fff;">
            <div class="w1200 dib tc">
                <div id="kki5a7yd-footerBottom" class="c_theme fs12 dib">{{ ast['kki5t8p1-footerBottom'].body[0].value }}</div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name:'kl_include_header',
    data() {
        return {
        }
    }
}
</script>

<style lang="less">
    @import (reference) "@/assets/less/base.less";
    #kki55zq0-footer{
        background: url('~@/assets/img/footer-bg.png');
        min-height: 315px;
        a:hover{
            color: #fff;
        }
    }
    #kki5a7yd-footerBottom{
        height: 40px;
        line-height: 40px;
        background-color: #fff;
    }
    // 主要内容
    #main-kkm04spl{
        .main-container{
            .dib;
            padding: 60px 20px;
            border-bottom: 1px solid #48b2d0;
            // ul 主要内容
            .main{
                .dib;
                .vm;
                li{
                    .dib;
                    vertical-align: top;
                    margin-right: 80px;
                    line-height: 30px;
                    // 服务热线
                    .fwrx{
                        position: relative;
                        top: -16px;
                    }
                }
            }
            //公众号盒子
            .gzh-box{
                .dib;
                .vm;
                margin-left: 100px;
                img{
                    width: 120px;
                }
            }
        }
    }
    // 友情链接
    #kkm0gpz1-link{
        height: 40px;
        line-height: 40px;
        a{
            padding: 0 10px;
            border-right: 1px solid #fff;
            &:last-child{
                border-right: none;
            }
        }
    }

</style>